import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router';
export default function IndInv() {
    const arrange = (data) => {
        return <div className='indrow'>
            <div style={{ fontWeight: 'bolder' }}>{data.head}</div>
            <div>{data.data}</div>
        </div>
    }
    let navigate = useNavigate();
    useEffect(async () => {
        console.log(str)
        let data = localStorage.getItem(`invoice-${str}`);
        if (!data)
            navigate('/invoice')
        // await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/Invoice_module/${str}/`, {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': `JWT ${localStorage.getItem('access')}`,
        //         'Accept': 'application/json'
        //     }
        // })
        //     .then(async response => {
        //         setData(response.data)
        //         console.log(response.data)
        //     }).catch(err => {
        //         console.log(err)
        //     })
        else
            localStorage.removeItem(`invoice-${str}`)
    }, [])
    let str = window.location.href.split('/');
    str = str[str.length - 1]
    const [data, setData] = useState(JSON.parse(localStorage.getItem(`invoice-${str}`)))
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let cur = JSON.parse(localStorage.getItem('currency'))
    let Scur = localStorage.getItem('selectedCurrency')
    let symbol = localStorage.getItem('symbol')
    return (
        <div className='indinv'>
            <div className='gridrow'>
                {arrange({ head: 'NAME', data: data.Get_detailes.name })}
                {arrange({ head: 'DATE', data: data.date })}
            </div>
            <div className='gridrow'>
                {arrange({ head: 'ADDRESS', data: data.Get_detailes.address })}
                {arrange({ head: 'INVOICE NO.', data: data.invoice_no })}
            </div><br /><br />
            <div className="gridrow">
                <div>
                    <b><u>Bill To</u></b><br />
                    Accounts<br />
                    FLYXAVI Solutions LLP<br />
                    Banglore 562107<br />
                    9173291723<br />
                    accounts@flyxavi.com<br />
                    <br/>
                    <b><u>Paid From</u></b><br />
                    {Object.keys(data.bank_detailes).map((item) => {
                        console.log( data.bank_detailes[item] )
                        if (data.bank_detailes[item] != null && data.bank_detailes[item].length != 0 && item != 'user' && item != 'id') return <>{item + ' : ' + data.bank_detailes[item]}<br/></>;
                        else return false
                    }) }{data.bank_detailes.Account_number?<></>:<b>Bank Details Not Provided</b>}
                </div>

                <div><b><u>Project Details</u></b><br />{data.project_name}<br /><br /><span style={{ fontWeight: '' }}>{data.project_detailes}</span></div>
            </div><br /><br />
            <table border='1'>
                <tr>
                    <th>DESCRIPTION</th><th>HOURS / DAYS</th><th>RATE</th><th>TOTAL</th>
                </tr>
                {data.Invoice_fields.map(inv => {
                    return <tr><td>{inv.sub_description}</td><td>{inv.unit + ' ' + inv.desc}</td>
                        <td>{numberWithCommas(inv.coast) + data.currency}</td>
                        <td>{numberWithCommas(inv.prizes) + data.currency}</td></tr>
                })}
                <tr><td></td><td></td><td></td><td><b>{numberWithCommas(data.Total_rate) + data.currency}</b></td></tr>
            </table>
            <div className='indinvB'>
                <button type='button' onClick={() => navigate(-1)} className='indinvsec'>Back</button>
                <button type='submit' onClick={() => { window.print() }}>Print</button>
            </div>
        </div>
    )
}
